var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 -0.00390625C16.7688 -0.00390625 18 1.22731 18 2.74609V15.2461C18 16.7649 16.7688 17.9961 15.25 17.9961H2.75C1.23122 17.9961 0 16.7649 0 15.2461V2.74609C0 1.22731 1.23122 -0.00390625 2.75 -0.00390625H15.25ZM4.75 5.9994C4.33579 5.9994 4 6.33374 4 6.74618V13.2526C4 13.6651 4.33579 13.9994 4.75 13.9994C5.16421 13.9994 5.5 13.6651 5.5 13.2526V6.74618C5.5 6.33374 5.16421 5.9994 4.75 5.9994ZM13.25 3.9994C12.8358 3.9994 12.5 4.32597 12.5 4.72881V13.27C12.5 13.6728 12.8358 13.9994 13.25 13.9994C13.6642 13.9994 14 13.6728 14 13.27V4.72881C14 4.32597 13.6642 3.9994 13.25 3.9994ZM8.9751 8.99609C8.57066 9.00013 8.24604 9.32852 8.25004 9.72964L8.28537 13.277C8.28936 13.6781 8.62046 14.0001 9.0249 13.9962C9.42934 13.9921 9.75396 13.6637 9.74996 13.2626L9.71463 9.71529C9.71064 9.31417 9.37954 8.9922 8.9751 8.99609Z",
    fill: "#5566AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.551d84ec.svg";
export { ForwardRef as ReactComponent };